import { useWorkspacesQuery as e } from "./useWorkspacesQuery.mjs";
import { useAuth as t } from "@maat/store-auth";
//#region src/workspaces/useActiveWorkspace.ts
var n = () => {
	let { activeWorkspaceId: n, isAuthenticated: r } = t(), { data: i, ...a } = e(r), o = i?.workspaces ?? [];
	return {
		workspace: n ? o.find((e) => e.id === n) ?? null : o[0] ?? null,
		workspaces: o,
		...a
	};
};
//#endregion
export { n as useActiveWorkspace };
